'use client';

import { useTranslations } from 'next-intl';
import styles from './ListingCard.module.css';
import type { CardLoadingProps } from './ListingCard.types';

const ListingCardLoading = ({ ariaLabel }: CardLoadingProps) => {
  const t = useTranslations('common');
  const label = ariaLabel ?? t('loading');

  return <output data-test-id="CardLoading" className={styles.dotFlashing} aria-label={label} />;
};

export { ListingCardLoading };
